import {
  Admin as RaAdmin,
  CoreLayoutProps,
  CustomRoutes,
  Resource,
  TranslationMessages,
  resolveBrowserLocale,
  defaultTheme
  // useStore
} from 'react-admin'
import {
  AppBar,
  Toolbar,
  Typography,
  styled,
  useMediaQuery
} from '@mui/material'
import polyglotI18nProvider from 'ra-i18n-polyglot'
import { isNil } from 'lodash/fp'
// import en from 'ra-language-english'
import { Route, useParams } from 'react-router-dom'
import log from 'loglevel'
import React from 'react'
// import reactManifest from 'react-manifest'
// import { indigo, blue, red } from '@mui/material/colors'

import { UserEdit, UserList, UserCreate, UserShow } from '../User'
import { PartnerEdit } from '../Partner'
import { PartnerRegisterCompleteForm, PartnerRegisterFailForm } from '../Credit'
import { ja } from './translations-ja'
import { en } from './translations-en'
import { DataProvider } from '../DataProvider'
import { Dashboard } from '../Dashboard'
import { CriterionComponent, CriterionList } from '../Criterion'
// import { OrderFormA, OrderCompleteFormA } from '../OrderFormA'
// import { OrderFormR, OrderCompleteFormR } from '../OrderFormR'
import {
  PartnerReportForm,
  PartnerReportCompleteForm
} from '../PartnerReportForm'
// import { BankAccountForm, BankAccountCompleteForm } from '../BankAccount'
import { InvoiceShow } from '../Invoice'
import {
  CodingAssesmentForm,
  CodingAssesmentCompleteForm,
  CodingAssesmentStartForm
} from '../CodingAssesmentForm'
import {
  SafetyAnswerForm,
  SafetyAnswerCompleteForm,
  SafetyReportForm,
  SafetyNotifyForm,
  SafetyCheckForm,
  SafetyCheckCompleteForm
} from '../Safety'
import { ScheduleForm, ScheduleCompleteForm } from '../Schedule'
import {
  SolarApprovalCompleteForm,
  SolarApprovalForm,
  SolarApprovalForm2
} from '../SolarApproval'
import { SolarData } from '../SolarData'

log.setLevel(log.levels.DEBUG)

const translations: Record<string, TranslationMessages> = { en, ja }

const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  zIndex: 1,
  minHeight: '100vh',
  backgroundColor: theme.palette.background.default,
  position: 'relative'
}))
const RootWithoutTitle = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  zIndex: 1,
  minHeight: '100vh',
  backgroundColor: '#fff',
  position: 'relative'
}))
const AppFrame = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  overflowX: 'auto'
}))
const Content = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  //   padding: theme.spacing(10),
  marginTop: '4em',
  marginLeft: '0'
}))
const ContentWithoutTitle = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  //   padding: theme.spacing(10),
  marginTop: '1em',
  marginLeft: '0'
}))
const MyLayout: React.FC<CoreLayoutProps> = ({ children, title }) => (
  <Root>
    <AppFrame>
      <MyAppBar title={title as string} />
      <Content>{children}</Content>
    </AppFrame>
  </Root>
)
const MyLayoutWithoutTitle: React.FC<CoreLayoutProps> = ({ children }) => (
  <RootWithoutTitle>
    <AppFrame>
      <ContentWithoutTitle>{children}</ContentWithoutTitle>
    </AppFrame>
  </RootWithoutTitle>
)
const i18nProvider = polyglotI18nProvider(
  (locale) =>
    !isNil(translations[locale])
      ? (translations[locale] as TranslationMessages)
      : (translations['en'] as TranslationMessages),
  resolveBrowserLocale(),
  [
    { locale: 'en', name: 'English' },
    { locale: 'ja', name: '日本語' }
  ]
  // { allowMissing: true }
)
const dataProvider = DataProvider()
export const setManifestURL = (id?: string | null): void => {
  const startUrl = !isNil(id)
    ? `${window.location.origin}/${id}`
    : window.location.href
  const manifest = {
    short_name: 'テラシテA',
    name: 'テラシテA',
    icons: [
      {
        src: `${window.location.origin}/favicon.ico`,
        sizes: '64x64 32x32 24x24 16x16',
        type: 'image/x-icon'
      },
      {
        src: `${window.location.origin}/logo192.png`,
        type: 'image/png',
        sizes: '192x192'
      },
      {
        src: `${window.location.origin}/logo512.png`,
        type: 'image/png',
        sizes: '512x512'
      }
    ],
    start_url: startUrl,
    display: 'standalone',
    theme_color: '#000000',
    background_color: '#ffffff'
  }
  const stringManifest = JSON.stringify(manifest)
  const blob = new Blob([stringManifest], { type: 'application/json' })
  const manifestURL = URL.createObjectURL(blob)
  document.querySelector('#manifest')?.setAttribute('href', manifestURL)
}
const Top: React.FC = () => {
  const params = useParams()
  // const redirect = useRedirect()
  // const [store, setStore] = useStore<string | null>('id', null)
  // const id = !isNil(params['id']) ? params['id'] : !isNil(store) ? store : null
  // React.useEffect(() => {
  //   if (isNil(store) && !isNil(params['id'])) setStore(params['id'])
  //   setManifestURL(id)
  // })
  // if (!isNil(store) && isNil(params['id'])) {
  //   redirect(`/${id as string}`)
  //   return <></>
  // }
  const id = !isNil(params['id']) ? params['id'] : null
  return !isNil(id) ? <Dashboard id={id} /> : <LandingPage />
}
const Result: React.FC = () => {
  const params = useParams()
  const result = params['result']
  const id = params['id']
  return !isNil(id) && !isNil(result) ? (
    result === 'START' ? (
      <Dashboard id={id} />
    ) : result === 'SUCCESS' ? (
      <PartnerRegisterCompleteForm id={id} />
    ) : (
      <PartnerRegisterFailForm id={id} />
    )
  ) : (
    <LandingPage />
  )
}
const Criterions: React.FC = () => {
  const params = useParams()
  return !isNil(params['id']) ? (
    <CriterionList id={params['id']} />
  ) : (
    <LandingPage />
  )
}
const CriterionEdit: React.FC = () => {
  const params = useParams()
  return !isNil(params['id']) ? (
    <CriterionComponent id={params['id']} />
  ) : (
    <LandingPage />
  )
}
const MyAppBar: React.FC<{
  title: string
}> = ({ title, ...props }) => (
  <AppBar title={title} {...props}>
    <Toolbar>
      <Typography variant="h6" id="react-admin-title" />
      <Typography
        variant="subtitle1"
        sx={{ marginTop: '0em', marginLeft: '1em' }}>
        {`${process.env['REACT_APP_VERSION'] as string}`}
      </Typography>
    </Toolbar>
  </AppBar>
)
const Register: React.FC = () => {
  const params = useParams()
  return !isNil(params['id']) ? (
    <PartnerEdit
      id={params['id']}
      resource="partners"
      title="mine.users.registerTitle"
      register
    />
  ) : (
    <LandingPage />
  )
}
const LandingPage: React.FC = () => {
  // const redirect = useRedirect()
  // redirect('https://www.terashite.jp/a')
  // redirect('/users')
  window.location.href = 'about:blank'
  return <></>
}
const AddHouse: React.FC = () => {
  const params = useParams()
  return !isNil(params['id']) ? (
    <UserCreate
      id={params['id']}
      resource="users"
      title="mine.users.addHouse"
    />
  ) : (
    <LandingPage />
  )
}
const Houses: React.FC = () => {
  const params = useParams()
  return !isNil(params['id']) ? (
    <UserList id={params['id']} resource="users" title="mine.users.houses" />
  ) : (
    <LandingPage />
  )
}
const HouseShow: React.FC = () => {
  const params = useParams()
  log.debug('[HouseShow]', params)
  return !isNil(params['id']) && !isNil(params['date']) ? (
    <UserShow
      id={params['id']}
      date={params['date']}
      resource="users"
      // title="mine.users.houseShow"
    />
  ) : (
    <LandingPage />
  )
}
const Partner: React.FC = () => {
  const params = useParams()
  return !isNil(params['id']) ? (
    <PartnerEdit id={params['id']} resource="partners" />
  ) : (
    <LandingPage />
  )
}
const Invoice: React.FC = () => {
  const params = useParams()
  const id = params['id']
  return !isNil(id) ? <InvoiceShow id={id} /> : <LandingPage />
}

export const Admin: React.FC = () => {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)')
  const isDesktop = useMediaQuery('(min-width: 900px)')
  return (
    <RaAdmin
      dataProvider={dataProvider}
      i18nProvider={i18nProvider}
      layout={MyLayout}
      theme={{
        ...defaultTheme,
        palette: {
          mode: prefersDarkMode ? 'dark' : 'light',
          primary: {
            main: '#f57800'
          },
          background: {
            paper: '#fff7e1',
            default: '#fff7e1'
          }
        },
        typography: isDesktop
          ? {}
          : {
              fontSize: 16,
              h6: {
                fontSize: 20,
                fontWeight: 700
              },
              subtitle1: {
                fontSize: 20,
                fontWeight: 700
              },
              caption: {
                fontSize: 16,
                fontWeight: 700
              },
              body1: {
                fontSize: 20,
                fontWeight: 700
              },
              button: {
                fontSize: 18,
                fontWeight: 700
              }
            }
      }}>
      <Resource name="users" edit={UserEdit} list={UserList} />
      <Resource name="partners" edit={PartnerEdit} />
      <CustomRoutes>
        <Route path="/" element={<Top />} />
        <Route path="/:id" element={<Top />} />
        <Route path="/:id/:result" element={<Result />} />
        <Route path="/criterions/:id" element={<Criterions />} />
        <Route path="/criterionEdit/:id" element={<CriterionEdit />} />
        <Route path="/register/:id" element={<Register />} />
        <Route path="/" element={<LandingPage />} />
        <Route path="/userCreate/:id" element={<AddHouse />} />
        <Route path="/usersList/:id" element={<Houses />} />
        <Route path="/userShow/:id/:date" element={<HouseShow />} />
        <Route path="/partners/:id" element={<Partner />} />
        <Route path="invoice/:id" element={<Invoice />} />
      </CustomRoutes>
    </RaAdmin>
  )
}

// export const AdminOrderA: React.FC = () => {
//   React.useEffect(() => {
//     document.title = 'テラシテA'
//   })
//   return (
//     <RaAdmin
//       dataProvider={dataProvider}
//       i18nProvider={i18nProvider}
//       layout={MyLayoutWithoutTitle}>
//       <Resource name="partners" />
//       <CustomRoutes>
//         <Route path="/" element={<OrderFormA />} />
//         <Route path="/forget" element={<OrderFormA forget />} />
//         <Route
//           path="/forget/complete/"
//           element={<OrderCompleteFormA forget />}
//         />
//         <Route path="/complete/" element={<OrderCompleteFormA />} />
//       </CustomRoutes>
//     </RaAdmin>
//   )
// }
// export const AdminOrderR: React.FC = () => {
//   const params = useParams()
//   const id = params['id']
//   const product = params['product']
//   React.useEffect(() => {
//     document.title = 'テラシテR'
//   })
//   return (
//     <RaAdmin
//       dataProvider={dataProvider}
//       i18nProvider={i18nProvider}
//       layout={MyLayoutWithoutTitle}>
//       <Resource name="partners" />
//       <CustomRoutes>
//         <Route
//           path="/"
//           element={<OrderFormR id={id as string} product={product as string} />}
//         />
//         <Route path="/complete/" element={<OrderCompleteFormR />} />
//       </CustomRoutes>
//     </RaAdmin>
//   )
// }
// export const AdminOrderRWithBankAccount: React.FC = () => {
//   const params = useParams()
//   const id = params['id']
//   const product = params['product']
//   React.useEffect(() => {
//     document.title = 'テラシテR'
//   })
//   return (
//     <RaAdmin
//       dataProvider={dataProvider}
//       i18nProvider={i18nProvider}
//       layout={MyLayoutWithoutTitle}>
//       <Resource name="partners" />
//       <Resource name="gmoPgs" />
//       <CustomRoutes>
//         <Route
//           path="/"
//           element={
//             <OrderFormR
//               id={id as string}
//               product={product as string}
//               bankAccount
//             />
//           }
//         />
//         <Route path="/complete/" element={<OrderCompleteFormR />} />
//         <Route path="/bankAccount/:id" element={<BankAccountForm />} />
//         <Route path="/:id/:result" element={<BankAccountCompleteForm />} />
//       </CustomRoutes>
//     </RaAdmin>
//   )
// }
export const AdminPartnerReport: React.FC = () => {
  const params = useParams()
  const id = params['id']
  React.useEffect(() => {
    document.title = 'テラシテR'
  })
  return (
    <RaAdmin
      dataProvider={dataProvider}
      i18nProvider={i18nProvider}
      layout={MyLayoutWithoutTitle}>
      <Resource name="partnerNotifications" />
      <CustomRoutes>
        <Route path="/" element={<PartnerReportForm id={id as string} />} />
        <Route
          path="/complete/"
          element={<PartnerReportCompleteForm id={id as string} />}
        />
      </CustomRoutes>
    </RaAdmin>
  )
}
export const AdminCodingAssement: React.FC = () => {
  const params = useParams()
  const id = params['id']
  React.useEffect(() => {
    document.title = '中部電力ミライズコネクト'
  })
  return (
    <RaAdmin
      dataProvider={dataProvider}
      i18nProvider={i18nProvider}
      layout={MyLayoutWithoutTitle}>
      <CustomRoutes>
        <Route path="/" element={<CodingAssesmentForm id={id as string} />} />
        <Route path="/complete/" element={<CodingAssesmentCompleteForm />} />
        <Route
          path="/start/"
          element={<CodingAssesmentStartForm id={id as string} />}
        />
      </CustomRoutes>
    </RaAdmin>
  )
}
export const AdminSafetyAnswer: React.FC = () => {
  const params = useParams()
  const id = params['id']
  React.useEffect(() => {
    document.title = 'テラシテR'
  })
  return (
    <RaAdmin
      dataProvider={dataProvider}
      i18nProvider={i18nProvider}
      layout={MyLayoutWithoutTitle}>
      <CustomRoutes>
        <Route path="/" element={<SafetyAnswerForm id={id as string} />} />
        <Route
          path="/complete/"
          element={<SafetyAnswerCompleteForm id={id as string} />}
        />
      </CustomRoutes>
    </RaAdmin>
  )
}
export const AdminSafetyReport: React.FC = () => {
  const params = useParams()
  const id = params['id']
  React.useEffect(() => {
    document.title = 'テラシテR'
  })
  return (
    <RaAdmin
      dataProvider={dataProvider}
      i18nProvider={i18nProvider}
      layout={MyLayoutWithoutTitle}>
      <CustomRoutes>
        <Route path="/" element={<SafetyReportForm id={id as string} />} />
      </CustomRoutes>
    </RaAdmin>
  )
}
export const AdminSafetyNotify: React.FC = () => {
  const params = useParams()
  const id = params['id']
  React.useEffect(() => {
    document.title = 'テラシテR'
  })
  return (
    <RaAdmin
      dataProvider={dataProvider}
      i18nProvider={i18nProvider}
      layout={MyLayoutWithoutTitle}>
      <CustomRoutes>
        <Route path="/" element={<SafetyNotifyForm id={id as string} />} />
      </CustomRoutes>
    </RaAdmin>
  )
}
export const AdminSafetyCheck: React.FC = () => {
  const params = useParams()
  const id = params['id']
  React.useEffect(() => {
    document.title = 'テラシテR'
  })
  return (
    <RaAdmin
      dataProvider={dataProvider}
      i18nProvider={i18nProvider}
      layout={MyLayoutWithoutTitle}>
      <CustomRoutes>
        <Route path="/" element={<SafetyCheckForm id={id as string} />} />
        <Route
          path="/complete/"
          element={<SafetyCheckCompleteForm id={id as string} />}
        />
      </CustomRoutes>
    </RaAdmin>
  )
}
export const AdminSchedule: React.FC = () => {
  const { id, notification, maxDays } = useParams()
  return (
    <RaAdmin
      dataProvider={dataProvider}
      i18nProvider={i18nProvider}
      layout={MyLayoutWithoutTitle}>
      <CustomRoutes>
        {/* <Route
          path="/complete/"
          element={<ScheduleCompleteForm id={id as string} />}
        /> */}
        <Route
          path="/"
          element={
            maxDays === 'complete' ? (
              <ScheduleCompleteForm id={id as string} />
            ) : (
              <ScheduleForm
                id={id as string}
                notification={notification as string}
                maxDays={maxDays}
              />
            )
          }
        />
      </CustomRoutes>
    </RaAdmin>
  )
}
export const AdminSolarApproval: React.FC = () => {
  const { partner, id } = useParams()
  if (isNil(id) || isNil(partner)) return null
  return (
    <RaAdmin
      dataProvider={dataProvider}
      i18nProvider={i18nProvider}
      layout={MyLayoutWithoutTitle}
      theme={{
        ...defaultTheme,
        palette: {
          primary: {
            main: '#f57800'
          },
          background: {
            paper: '#fff7e1',
            default: '#fff7e1'
          }
        },
        typography: {
          fontSize: 16,
          h6: {
            fontSize: 24,
            fontWeight: 700
          },
          subtitle1: {
            fontSize: 18,
            fontWeight: 700
          },
          caption: {
            fontSize: 14,
            fontWeight: 700
          },
          body1: {
            fontSize: 16,
            fontWeight: 700
          },
          button: {
            fontSize: 16,
            fontWeight: 700
          }
        }
      }}>
      <Resource name="partners" />
      <CustomRoutes>
        <Route
          path="/"
          element={<SolarApprovalForm id={id} partner={partner} />}
        />
        <Route path="/complete/" element={<SolarApprovalCompleteForm />} />
      </CustomRoutes>
    </RaAdmin>
  )
}
export const AdminSolarApproval2: React.FC = () => {
  const { partner, id, hash } = useParams()
  if (isNil(id) || isNil(partner) || isNil(hash)) return null
  return (
    <RaAdmin
      dataProvider={dataProvider}
      i18nProvider={i18nProvider}
      layout={MyLayoutWithoutTitle}
      theme={{
        ...defaultTheme,
        palette: {
          primary: {
            main: '#f57800'
          },
          background: {
            paper: '#fff7e1',
            default: '#fff7e1'
          }
        },
        typography: {
          fontSize: 16,
          h6: {
            fontSize: 24,
            fontWeight: 700
          },
          subtitle1: {
            fontSize: 18,
            fontWeight: 700
          },
          caption: {
            fontSize: 14,
            fontWeight: 700
          },
          body1: {
            fontSize: 16,
            fontWeight: 700
          },
          button: {
            fontSize: 16,
            fontWeight: 700
          }
        }
      }}>
      <Resource name="partners" />
      <CustomRoutes>
        <Route
          path="/"
          element={<SolarApprovalForm2 id={id} partner={partner} hash={hash} />}
        />
        <Route path="/complete/" element={<SolarApprovalCompleteForm />} />
      </CustomRoutes>
    </RaAdmin>
  )
}
export const AdminSolarData: React.FC = () => {
  const { partner, hash } = useParams()
  if (isNil(partner) || isNil(hash)) return null
  return (
    <RaAdmin
      dataProvider={dataProvider}
      i18nProvider={i18nProvider}
      layout={MyLayoutWithoutTitle}
      theme={{
        ...defaultTheme,
        palette: {
          primary: {
            main: '#f57800'
          },
          background: {
            paper: '#fff7e1',
            default: '#fff7e1'
          }
        },
        typography: {
          fontSize: 16,
          h6: {
            fontSize: 24,
            fontWeight: 700
          },
          subtitle1: {
            fontSize: 18,
            fontWeight: 700
          },
          caption: {
            fontSize: 14,
            fontWeight: 700
          },
          body1: {
            fontSize: 16,
            fontWeight: 700
          },
          button: {
            fontSize: 16,
            fontWeight: 700
          }
        }
      }}>
      <CustomRoutes>
        <Route path="/" element={<SolarData partner={partner} hash={hash} />} />
      </CustomRoutes>
    </RaAdmin>
  )
}
